import * as React from 'react';
import { FeedbackMessageModel } from '../../hooks/useFeedbackMessages';
import * as i18next from 'i18next';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

interface IProps {
    messages: FeedbackMessageModel[];
    openAdminModal: (message: FeedbackMessageModel) => void;
    openSite: (siteId: number) => void;
}

function FeedbackMessageList({ messages, openAdminModal, openSite }: IProps) {
    return (
        <Box>
            <Typography variant="h5" fontWeight={600} gutterBottom>
                {i18next.t('adminfeedback.title')}
            </Typography>
            <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
                <Table size="small">
                    <TableHead>
                        <TableRow sx={{ bgcolor: 'background.paper' }}>
                            <TableCell sx={{ fontWeight: 600 }}>{i18next.t('adminfeedback.created')}</TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>{i18next.t('adminfeedback.driverid')}</TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>{i18next.t('adminfeedback.message')}</TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>{i18next.t('adminfeedback.editsite')}</TableCell>
                            <TableCell sx={{ width: 60 }} />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {messages.map((message, index) =>
                            <TableRow key={index} hover>
                                <TableCell>{moment(message.createdDate).format('L')}</TableCell>
                                <TableCell>{message.driverId}</TableCell>
                                <TableCell sx={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {message.message}
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        component="a"
                                        onClick={() => openSite(message.uniqueSiteId)}
                                        sx={{ cursor: 'pointer', color: 'secondary.main', display: 'flex', alignItems: 'center', gap: 0.5 }}
                                    >
                                        {message.siteName}
                                        <OpenInNewIcon sx={{ fontSize: 14 }} />
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <IconButton size="small" color="primary" onClick={() => openAdminModal(message)}>
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}

export default withTranslation('translations')(FeedbackMessageList);
